import { jsxs as H, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as l } from "./index.es2447.js";
function i({ size: V = l }) {
  return /* @__PURE__ */ H(
    "svg",
    {
      width: V,
      height: V,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.936646", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M25.5 16.9366H21.7228C21.0474 16.9366 20.5 17.5152 20.5 18.2279V18.8683H25.5V16.9366Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M35.5 16.9366H31.7228C31.0474 16.9366 30.5 17.5152 30.5 18.2279V18.8683H35.5V16.9366Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.7228 28.9366H19.5V25.0253C19.5 23.959 20.4118 23.0936 21.5352 23.0936H24.4648C25.5893 23.0936 26.5 23.959 26.5 25.0253V28.958C26.5722 28.944 26.6467 28.9366 26.7228 28.9366H29.5V25.0253C29.5 23.959 30.4118 23.0936 31.5352 23.0936H34.4648C35.5893 23.0936 36.5 23.959 36.5 25.0253V28.9366H39.5V30.8683H36.5V35.0936H38.4648C39.5893 35.0936 40.5 35.959 40.5 37.0253V40.3915H33.5V38.3915H31V39.9366H25V38.3915H22.5V40.3915H15.5V37.0253C15.5 35.959 16.4118 35.0936 17.5352 35.0936H19.5V30.8683H16.5V30.2279C16.5 29.5152 17.0474 28.9366 17.7228 28.9366ZM29.5 30.8683H26.5V34.9544C26.5799 34.9427 26.6615 34.9366 26.7444 34.9366H29.2556C29.3385 34.9366 29.4201 34.9427 29.5 34.9544V30.8683Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M20.5 18.7474H25.5V21.0432C25.5 22.4523 24.4088 23.6055 23.0745 23.6055H22.9246C21.5912 23.6055 20.5 22.4523 20.5 21.0432V18.7474Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M30.5 18.7474H35.5V21.0432C35.5 22.4523 34.4088 23.6055 33.0745 23.6055H32.9246C31.5912 23.6055 30.5 22.4523 30.5 21.0432V18.7474Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M21.5 30.7474H16.5V33.0432C16.5 34.4523 17.5912 35.6055 18.9246 35.6055H19.0745C20.4088 35.6055 21.5 34.4523 21.5 33.0432V30.7474Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M34.5 30.7474H39.5V33.0432C39.5 34.4523 38.4088 35.6055 37.0745 35.6055H36.9246C35.5912 35.6055 34.5 34.4523 34.5 33.0432V30.7474Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M30.5 30.7474H25.5V33.0432C25.5 34.4523 26.5912 35.6055 27.9246 35.6055H28.0745C29.4088 35.6055 30.5 34.4523 30.5 33.0432V30.7474Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7228 16.4366C20.7459 16.4366 20 17.2652 20 18.2279V21.0432C20 21.6878 20.1947 22.2938 20.5287 22.7939C19.6382 23.1643 19 24.0118 19 25.0253V28.4366H17.7228C16.7459 28.4366 16 29.2652 16 30.2279V33.0432C16 33.6878 16.1947 34.2938 16.5287 34.7939C15.6382 35.1643 15 36.0118 15 37.0253V40.3916C15 40.6677 15.2239 40.8916 15.5 40.8916H22.5C22.7761 40.8916 23 40.6677 23 40.3916V38.8916H24V40.3916C24 40.6677 24.2239 40.8916 24.5 40.8916H31.5C31.7761 40.8916 32 40.6677 32 40.3916V38.8916H33V40.3916C33 40.6677 33.2239 40.8916 33.5 40.8916H40.5C40.7761 40.8916 41 40.6677 41 40.3916V37.0253C41 36.0118 40.3622 35.164 39.4714 34.7937C39.8054 34.2937 40 33.6877 40 33.0432V28.4366H37V25.0253C37 24.0118 36.3622 23.164 35.4714 22.7937C35.8054 22.2937 36 21.6877 36 21.0432V16.4366H31.7228C30.7459 16.4366 30 17.2652 30 18.2279V21.0432C30 21.6878 30.1947 22.2938 30.5287 22.7939C29.6382 23.1643 29 24.0118 29 25.0253V28.4366H27V25.0253C27 24.0118 26.3622 23.164 25.4714 22.7937C25.8054 22.2937 26 21.6877 26 21.0432V16.4366H21.7228ZM30 28.4366H31V33.0432C31 33.6877 30.8054 34.2937 30.4714 34.7937C31.3622 35.164 32 36.0118 32 37.0253V37.8916H33V37.0253C33 36.0118 33.6382 35.1643 34.5287 34.7939C34.1947 34.2938 34 33.6878 34 33.0432V30.2279C34 29.2652 34.7459 28.4366 35.7228 28.4366H36V25.0253C36 24.3214 35.4409 23.7023 34.6728 23.6065C34.2156 23.9209 33.6678 24.1055 33.0745 24.1055H32.9246C32.3316 24.1055 31.7841 23.9209 31.327 23.6066C30.5597 23.7025 30 24.3217 30 25.0253V28.4366ZM22 33.0432V28.4366H20V25.0253C20 24.3217 20.5597 23.7025 21.327 23.6066C21.7841 23.9209 22.3316 24.1055 22.9246 24.1055H23.0745C23.6678 24.1055 24.2156 23.9209 24.6728 23.6065C25.4409 23.7023 26 24.3214 26 25.0253V28.6004C25.401 28.8883 25 29.522 25 30.2279V33.0432C25 33.6878 25.1947 34.2938 25.5287 34.7939C24.6382 35.1643 24 36.0118 24 37.0253V37.8916H23V37.0253C23 36.0118 22.3622 35.164 21.4714 34.7937C21.8054 34.2937 22 33.6877 22 33.0432ZM21 19.3683H25V21.0432C25 22.2024 24.1071 23.1055 23.0745 23.1055H22.9246C21.893 23.1055 21 22.2026 21 21.0432V19.3683ZM21 18.2279C21 17.7652 21.349 17.4366 21.7228 17.4366H25V18.3683H21V18.2279ZM16 37.0253C16 36.3217 16.5597 35.7025 17.327 35.6066C17.7841 35.9209 18.3316 36.1055 18.9246 36.1055H19.0745C19.6678 36.1055 20.2156 35.9209 20.6728 35.6065C21.4409 35.7023 22 36.3214 22 37.0253V39.8916H16V37.0253ZM21 31.3683V33.0432C21 34.2024 20.1071 35.1055 19.0745 35.1055H18.9246C17.893 35.1055 17 34.2026 17 33.0432V31.3683H21ZM17 30.2279C17 29.7652 17.349 29.4366 17.7228 29.4366H21V30.3683H17V30.2279ZM25 37.0253C25 36.3217 25.5597 35.7025 26.327 35.6066C26.7841 35.9209 27.3316 36.1055 27.9246 36.1055H28.0745C28.6678 36.1055 29.2156 35.9209 29.6728 35.6065C30.4409 35.7023 31 36.3214 31 37.0253V39.8916H25V37.0253ZM26 31.3683H30V33.0432C30 34.2024 29.1071 35.1055 28.0745 35.1055H27.9246C26.893 35.1055 26 34.2026 26 33.0432V31.3683ZM26 30.2279C26 29.7652 26.349 29.4366 26.7228 29.4366H30V30.3683H26V30.2279ZM31 19.3683H35V21.0432C35 22.2024 34.1071 23.1055 33.0745 23.1055H32.9246C31.893 23.1055 31 22.2026 31 21.0432V19.3683ZM31 18.2279C31 17.7652 31.349 17.4366 31.7228 17.4366H35V18.3683H31V18.2279ZM35.327 35.6066C34.5597 35.7025 34 36.3217 34 37.0253V39.8916H40V37.0253C40 36.3214 39.4409 35.7023 38.6728 35.6065C38.2156 35.9209 37.6678 36.1055 37.0745 36.1055H36.9246C36.3316 36.1055 35.7841 35.9209 35.327 35.6066ZM35 31.3683V33.0432C35 34.2026 35.893 35.1055 36.9246 35.1055H37.0745C38.1071 35.1055 39 34.2024 39 33.0432V31.3683H35ZM35.7228 29.4366C35.349 29.4366 35 29.7652 35 30.2279V30.3683H39V29.4366H35.7228Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
i.__tags = [];
export {
  i as MetricPopulationIcon
};
//# sourceMappingURL=index.es419.js.map
